$(function () {
    $('.js-cookie').cookie();
    $('.user-select').on('change', function () {
        var href = $(this).find('option').filter(':selected').data('href');
        if (!href) {
            return;
        }

        document.location.href = href;
    });
});
